<template>
  <div>
    <div class="custom-search d-flex justify-content-between mb-1">
      <div>
        <slot name="component-between-search" />
      </div>
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Cari</label>
          <b-form-input
            v-model="searchVal"
            placeholder="Tekan Enter"
            type="text"
            class="d-inline-block"
            @keyup.enter="handleSearch"
          />
        </div>
      </b-form-group>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: search,
      }"
      :pagination-options="{
        enabled: true,
        perPage: perPage,
        jumpFirstOrLast: true,
      }"
      :total-rows="totalRecords"
      :is-loading="isLoading"
      mode="remote"
      :select-options="{
        enabled: isSelected,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      @on-sort-change="onSortChange"
      @on-selected-rows-change="selectionChangedTable"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <slot
          name="custom-column"
          :props="props"
        />
        <!-- Column: aksi -->
        <!-- <span v-if="props.column.field === 'aksi'">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="text-body align-middle mr-25"
              />
            </template>
            <b-dropdown-item
              v-for="(item, index) of getAksi(props.row)"
              :key="index"
              :to="item.to"
            >
              <feather-icon
                :icon="item.icon"
                class="mr-50"
              />
              <span>{{ item.buttonLabel }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </span> -->

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Menampilkan 1 hingga </span>
            <b-form-select
              v-model="perPageVal"
              :options="['10', '100', '1000']"
              class="mx-1"
              @input="handlePageChange"
            />
            <span class="text-nowrap">
              dari {{ totalRecords }} entri
            </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table'
import { ref } from '@vue/composition-api'
import {
  propsArray, propsFunction, propsString, propsNumber, propsBoolean,
} from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const perPageVal = ref(props.perPage)
    const searchVal = ref(props.search)

    const handlePageChange = () => {
      context.emit('emitPerPage', perPageVal.value)
    }

    const handleSearch = () => {
      context.emit('emitSearch', searchVal.value)
    }

    return {
      perPageVal, searchVal, handlePageChange, handleSearch,
    }
  },
  components: {
    VueGoodTable,
  },
  props: {
    rows: propsArray,
    columns: propsArray,
    search: propsString,
    perPage: propsNumber,
    totalRecords: propsNumber,
    isLoading: propsBoolean,
    onSortChange: propsFunction,
    isSelected: propsBoolean,
    selectionChangedTable: propsFunction,
    handleChangePage: propsFunction,
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
